// Ad slots configuration (Profiton or any ad network).
//
// HOW TO ADD AN AD:
// 1. Copy the raw snippet the ad network gives you (HTML and/or <script> tags).
// 2. Paste it between the backticks of `code` for the slot you want, e.g.
//      home_top: { enabled: true, code: `<script src="https://example.com/ad.js" data-zone="123"></script>` },
// 3. Save. <script> tags are executed automatically and re-run on every page change.
//
// - enabled: false hides the slot completely, even if code is set.
// - code: "" (empty) renders nothing for visitors. Add ?ads=preview to any URL to see
//   placeholders for every empty slot (e.g. https://yoursite.com/?ads=preview).
// - Snippets that rely on document.write() won't work after page load; ask the network
//   for an async/"tag" version instead.
// - Network-wide scripts (popunder, push, etc.) go in public/index.html, see the
//   "PROFITON GLOBAL SCRIPT" comment in <head>.
//
// Slot locations:
//   home_top      Home, below the hero banner
//   home_middle   Home, between the movie rows and the TV rows
//   detail_top    Movie & TV detail, below the hero / Watch Now area
//   detail_bottom Movie & TV detail, above the "More Like This" row
//   catalog_top   /movies and /tv, above the poster grid
//   footer        All pages, just above the footer

export const ADS = {
  home_top: { enabled: true, code: `` },
  home_middle: { enabled: true, code: `` },
  detail_top: { enabled: true, code: `` },
  detail_bottom: { enabled: true, code: `` },
  catalog_top: { enabled: true, code: `` },
  footer: { enabled: true, code: `` },
};
